/**
 * ScenarioMismatchWarning — Shown in the test harness when a user's modifications
 * have changed a named test case so that it no longer matches the original assumptions.
 */

import React from 'react';
import { AlertTriangle } from 'lucide-react';
import type { ScenarioMismatch } from '../../server/services/scenarioClassifier';

interface Props {
    mismatch: ScenarioMismatch | null;
}

export const ScenarioMismatchWarning: React.FC<Props> = ({ mismatch }) => {
    if (!mismatch) return null;

    return (
        <div className="rounded-lg border border-amber-300 bg-amber-50 p-3 mb-3">
            <div className="flex items-start gap-2">
                <AlertTriangle className="w-4 h-4 text-amber-600 flex-shrink-0 mt-0.5" />
                <div>
                    <p className="text-sm font-semibold text-amber-800">
                        {mismatch.message}
                    </p>
                    <ul className="mt-1.5 space-y-0.5 text-xs text-amber-700">
                        {mismatch.reasons.map((r, i) => (
                            <li key={i} className="flex items-start gap-1.5">
                                <span className="mt-1 w-1 h-1 rounded-full bg-amber-500 flex-shrink-0" />
                                {r}
                            </li>
                        ))}
                    </ul>
                    <p className="mt-2 text-xs text-amber-600 italic">
                        Base preset checks are paused — the comparison below is informational only.
                    </p>
                </div>
            </div>
        </div>
    );
};
